import { useContext, useEffect, useState } from 'react';
import {
  ControlPopupContainer,
  ControlPopupContent,
  PopupMenu,
  PopupMenuItem,
} from './styles';
import { SelectionRange } from '../../EditablePage/EditableBlock';
import { TrashSimple, X } from '@phosphor-icons/react';
import { INITIAL_CONTROLS, useStore } from '../../../../store';
import { TtsContext } from '../../../../contexts/TtsContext';

interface StylePopupProps {
  blockId: string;
  selection?: SelectionRange | undefined;
  selectionId?: string;
}

interface Options {
  value: string;
  label: string;
}

export const StylePopup = ({
  selection,
  blockId,
  selectionId,
}: StylePopupProps) => {
  const {
    blocks,
    updateBlockControl,
    createEffectSelection,
    removeEffectFromSelection,
  } = useStore();
  const { hideToolbox } = useContext(TtsContext);

  const [style, setStyle] = useState<string>();
  const [options, setOptions] = useState<Options[]>([]);

  const index = blocks.findIndex((b) => b.id === blockId);

  function handleChange(value: string | undefined) {
    setStyle(value);
    if (selection && value) {
      createEffectSelection(
        blockId,
        selection.start,
        selection.end,
        'style',
        value
      );
    } else {
      updateBlockControl(blockId, 'style', value);
    }
    hideToolbox();
  }

  useEffect(() => {
    const styles = blocks[index]?.controls.speaker.styles?.map((style) => ({
      value: style,
      label: style.charAt(0).toUpperCase() + style.slice(1),
    }));

    setOptions(styles || []);

    if (selectionId) {
      const value = blocks[index]?.selections
        ?.find((selection) => selection.id === selectionId)
        ?.controls.find((c) => c.control === 'style')?.value as
        | string
        | undefined;

      setStyle(value);
    } else {
      selection
        ? setStyle(undefined)
        : setStyle(blocks[index]?.controls?.style);
    }
  }, [blocks, index, selection, selectionId]);

  return (
    <ControlPopupContainer>
      <ControlPopupContent>
        <PopupMenu>
          {options && options.length <= 0 ? (
            <span style={{ padding: '6px', textAlign: 'center' }}>
              No styles available for this voice
            </span>
          ) : (
            options.map((option) => (
              <PopupMenuItem
                isSelected={style === option.value}
                key={crypto.randomUUID() + `style-options-` + option.value}
                onClick={() => handleChange(option.value)}
              >
                {option.label}
              </PopupMenuItem>
            ))
          )}
        </PopupMenu>
      </ControlPopupContent>
      {style &&
        (selectionId ? (
          <PopupMenuItem
            isSelected={false}
            onClick={() => {
              removeEffectFromSelection(blockId, selectionId, 'style')
              hideToolbox()
            }
            }
            style={{ border: '1px solid #fd6262' }}
          >
            <X />
            Clear
          </PopupMenuItem>
        ) : (
          <PopupMenuItem
            isSelected={false}
            onClick={() => handleChange({ ...INITIAL_CONTROLS }.style)}
            style={{ border: '1px solid #fd6262' }}
          >
            <X />
            Clear
          </PopupMenuItem>
        ))}
    </ControlPopupContainer>
  );
};
